import {Component, ElementRef, EventEmitter, HostBinding, OnDestroy, OnInit, Output, Renderer2} from '@angular/core';

import {BBS_CATEGORY} from "../../shared/defines/protocol";
import {SASEUNG_HELP_BBS_ID} from "../../shared/defines/desktop.const";
import {GlobalEventService} from "../../shared/services/global-event/global-event.service";
import {Saseung3StatsService, SASEUNG3_STATS_FALLBACK} from "../../shared/services/saseung3-stats/saseung3-stats.service";
import {clickOutsideLinkMixin} from "../../shared/mixin/click-outside.mixin";

@Component({
  selector: 'app-saseung3-help-popup',
  templateUrl: './saseung3-help-popup.component.html',
  styleUrls: ['./saseung3-help-popup.component.scss']
})
export class Saseung3HelpPopupComponent extends clickOutsideLinkMixin implements OnInit, OnDestroy {
  @HostBinding('class') class = 'help-contents-box';
  @Output() close = new EventEmitter<boolean | null>()

  protected readonly BBS_CATEGORY = BBS_CATEGORY;
  protected readonly SASEUNG_HELP_BBS_ID = SASEUNG_HELP_BBS_ID;

  characterTotalCount = SASEUNG3_STATS_FALLBACK.character_total_count;
  toneMarkedCharacterCount = SASEUNG3_STATS_FALLBACK.tone_marked_character_count;

  constructor(
    public override elementRef: ElementRef,
    public override renderer: Renderer2,
    public override globalEventSvc: GlobalEventService,
    private statsSvc: Saseung3StatsService,
  ) {
    super(elementRef, renderer, globalEventSvc);
  }

  ngOnInit() {
    this.coInit((event: MouseEvent|TouchEvent) => {
      if (!this.elementRef.nativeElement.parentNode.contains(event.target)) {
        this.close.emit(null);
      }
    });

    this.statsSvc.Get().subscribe((stats) => {
      this.characterTotalCount = stats.character_total_count;
      this.toneMarkedCharacterCount = stats.tone_marked_character_count;
    });
  }

  ngOnDestroy() {
    this.coDestroy();
  }

  /**
   * 닫기 버튼 클릭 시 호출되는 이벤트
   * @param event - 이벤트
   * @param showSaseung - 사성 표시 여부
   *  @type {boolean | null}
   *  @default null - 사성 표시 여부 변경 없음
   *  @example true - 사성 표시
   *  @example false - 사성 미표시
   */
  onClose(event: MouseEvent, showSaseung: boolean | null = null) {
    // console.log('Saseung3HelpPopupComponent::onClose()');

    event.preventDefault();
    event.stopPropagation();
    this.globalEventSvc.Click(event);

    this.close.emit(showSaseung);
  }
}
